// Nugenyx UpCart drawer enhancements, revision 2.
(() => {
  const configElement = document.currentScript;
  const labels = {
    basket: configElement?.dataset.basketLabel || 'Your Basket',
    checkout: configElement?.dataset.checkoutLabel || 'Checkout Securely',
    points: configElement?.dataset.pointsLabel || 'Earn [points] Nugenyx+ points',
    benefitImage: configElement?.dataset.benefitImage || '',
    benefitTitle: configElement?.dataset.benefitTitle || 'Free Nugenyx travel case',
    benefitText:
      configElement?.dataset.benefitText ||
      'Included with your first qualifying pen order.',
    subtotal: configElement?.dataset.subtotalLabel || 'Subtotal',
    shipping: configElement?.dataset.shippingLabel || 'Shipping',
    shippingFree: configElement?.dataset.shippingFreeLabel || 'Free',
    shippingCalculated:
      configElement?.dataset.shippingCalculatedLabel || 'Calculated at checkout',
  };

  const styleId = 'nugenyx-upcart-enhancements';
  const extrasClass = 'nugenyx-upcart-extras';
  let rootObserver;
  let updateTimer;
  let pointsRequest;
  let lastPoints;
  let lastPointsRequestAt = 0;

  const icons = {
    lock: `
      <svg aria-hidden="true" viewBox="0 0 24 24" width="19" height="19" fill="none">
        <rect x="5" y="10" width="14" height="11" rx="2" stroke="currentColor" stroke-width="1.8"></rect>
        <path d="M8.5 10V7.5a3.5 3.5 0 0 1 7 0V10" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path>
      </svg>`,
    star: `
      <svg aria-hidden="true" viewBox="0 0 24 24" width="20" height="20" fill="none">
        <path d="m12 2.75 2.82 5.72 6.31.92-4.56 4.45 1.08 6.28L12 17.15l-5.65 2.97 1.08-6.28-4.56-4.45 6.31-.92L12 2.75Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"></path>
      </svg>`,
  };

  const injectStyles = (root) => {
    if (root.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      #CartPopup .upcart-internal-header {
        padding: 20px 24px !important;
      }

      #CartPopup .upcart-internal-header h4 {
        font-size: 21px !important;
        font-weight: 700 !important;
        letter-spacing: 0 !important;
      }

      #CartPopup .upcart-cart-body {
        background: #fff !important;
      }

      #CartPopup .styles_CartPreview__bottomModules__ {
        margin-top: 12px !important;
      }

      #CartPopup .${extrasClass} {
        display: grid;
        gap: 10px;
        padding: 16px 22px 8px;
      }

      #CartPopup .nugenyx-upcart-loyalty,
      #CartPopup .nugenyx-upcart-benefit {
        display: flex;
        align-items: center;
        gap: 12px;
        border-radius: 8px;
        padding: 15px 16px;
        line-height: 1.3;
      }

      #CartPopup .nugenyx-upcart-loyalty {
        -webkit-appearance: none;
        appearance: none;
        border: 0;
        color: #005f63;
        background: #d8f1f0;
        cursor: pointer;
        font-family: inherit;
        font-size: 16px;
        margin: 0;
        text-align: left;
        width: 100%;
      }

      #CartPopup .nugenyx-upcart-loyalty:hover {
        background: #c9e9e7;
      }

      #CartPopup .nugenyx-upcart-loyalty:focus-visible {
        outline: 2px solid #018589;
        outline-offset: 2px;
      }

#CartPopup .nugenyx-upcart-loyalty strong {
  font-weight: 700;
}

#CartPopup .nugenyx-upcart-loyalty__link {
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
}

#CartPopup .nugenyx-upcart-benefit {
  align-items: flex-start;
  color: #202020;
  background: #f2f3f3;
}

#CartPopup .nugenyx-upcart-benefit__media {
  flex: 0 0 72px;
  width: 72px;
  height: 54px;
  overflow: hidden;
  border-radius: 6px;
  background: #fff;
}

#CartPopup .nugenyx-upcart-benefit__media img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

#CartPopup .nugenyx-upcart-benefit__copy {
  min-width: 0;
}

#CartPopup .nugenyx-upcart-benefit__icon {
  color: #018589;
  flex: 0 0 auto;
        margin-top: 1px;
      }

      #CartPopup .nugenyx-upcart-benefit__title {
        display: block;
        font-size: 15px;
        font-weight: 700;
        margin-bottom: 2px;
      }

      #CartPopup .nugenyx-upcart-benefit__text {
        display: block;
        color: #5d6060;
        font-size: 14px;
      }

      #CartPopup .upcart-footer {
        background: #fff !important;
        padding-top: 0 !important;
      }

      #CartPopup .nugenyx-upcart-summary {
        display: grid;
        gap: 7px;
        margin: 0 22px 12px;
        padding-top: 14px;
        border-top: 1px solid #dedede;
        color: #202020;
        font-size: 15px;
      }

      #CartPopup .nugenyx-upcart-summary__row {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        gap: 20px;
      }

      #CartPopup .nugenyx-upcart-summary__row:first-child {
        font-weight: 700;
      }

      #CartPopup .nugenyx-upcart-summary__shipping {
        color: #666;
        font-size: 13px;
      }

      #CartPopup .nugenyx-upcart-summary__value {
        text-align: right;
      }

      #CartPopup .upcart-checkout-button {
        align-items: center !important;
        background: #050505 !important;
        border-radius: 999px !important;
        color: #fff !important;
        display: flex !important;
        gap: 10px !important;
        justify-content: center !important;
        min-height: 62px !important;
        transition: background-color 180ms ease, color 180ms ease !important;
      }

      #CartPopup .upcart-checkout-button *,
      #CartPopup .upcart-checkout-button *::before,
      #CartPopup .upcart-checkout-button *::after {
        background: transparent !important;
        background-image: none !important;
        box-shadow: none !important;
        color: inherit !important;
      }

      #CartPopup .upcart-checkout-button:hover,
      #CartPopup .upcart-checkout-button:focus-visible {
        background: #018589 !important;
        color: #fff !important;
      }

      #CartPopup .nugenyx-upcart-checkout__icon {
        display: inline-flex;
      }

      @media (max-width: 600px) {
        #CartPopup .upcart-internal-header {
          padding: 17px 18px !important;
        }

        #CartPopup .upcart-internal-header h4 {
          font-size: 19px !important;
        }

        #CartPopup .${extrasClass} {
          padding: 13px 15px 6px;
        }

        #CartPopup .styles_CartPreview__bottomModules__ {
          margin-top: 8px !important;
        }

  #CartPopup .nugenyx-upcart-loyalty,
  #CartPopup .nugenyx-upcart-benefit {
    padding: 13px 14px;
  }

  #CartPopup .nugenyx-upcart-benefit__media {
    flex-basis: 64px;
    width: 64px;
    height: 48px;
  }

        #CartPopup .nugenyx-upcart-loyalty {
          font-size: 15px;
        }

        #CartPopup .upcart-checkout-button {
          min-height: 56px !important;
        }

        #CartPopup .nugenyx-upcart-summary {
          margin: 0 15px 10px;
          padding-top: 12px;
        }
      }
    `;
    root.appendChild(style);
  };

  const formatMoney = (amount, currency = 'GBP') => {
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency,
      }).format((amount || 0) / 100);
    } catch (_) {
      return `£${((amount || 0) / 100).toFixed(2)}`;
    }
  };

  const ensureSummary = (root) => {
    const footer = root.querySelector('.upcart-footer');
    const checkoutWrapper = root.querySelector('.styles_Footer__checkoutButton__');
    if (!footer || !checkoutWrapper) return;

    let summary = footer.querySelector('.nugenyx-upcart-summary');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'nugenyx-upcart-summary';
      summary.innerHTML = `
        <div class="nugenyx-upcart-summary__row">
          <span>${labels.subtotal}</span>
          <span class="nugenyx-upcart-summary__value nugenyx-upcart-summary__subtotal"></span>
        </div>
        <div class="nugenyx-upcart-summary__row nugenyx-upcart-summary__shipping">
          <span>${labels.shipping}</span>
          <span class="nugenyx-upcart-summary__value nugenyx-upcart-summary__shipping-value"></span>
        </div>
      `;
      footer.insertBefore(summary, checkoutWrapper);
    }
  };

  const openRivoLauncher = () => {
    const launcher = document.querySelector(
      '#launcher-wrapper .ba-met-handler, #launcher-wrapper'
    );
    if (!(launcher instanceof HTMLElement)) return false;

    if (typeof window.MouseEvent === 'function') {
      ['mousedown', 'mouseup', 'click'].forEach((type) => {
        launcher.dispatchEvent(
          new MouseEvent(type, {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
      });
    } else {
      launcher.click();
    }

    return true;
  };

  const openRivoWhenReady = () => {
    if (openRivoLauncher()) return;

    let attempts = 0;
    const interval = window.setInterval(() => {
      attempts += 1;
      if (openRivoLauncher() || attempts >= 20) {
        window.clearInterval(interval);
      }
    }, 150);
  };

  const renderPointsLabel = (points) =>
    labels.points
      .replace('[points]', `<strong>${points}</strong>`)
      .replace(
        /Nugenyx\+\s+points/i,
        '<span class="nugenyx-upcart-loyalty__link">$&</span>'
      );

  const ensureExtras = (root) => {
    const modules = root.querySelector('.styles_CartPreview__bottomModules__');
    if (!modules) return;

    let extras = modules.querySelector(`.${extrasClass}`);
    if (!extras) {
      extras = document.createElement('div');
      extras.className = extrasClass;
      extras.innerHTML = `
      <button
        type="button"
        class="nugenyx-upcart-loyalty"
        aria-label="Open Nugenyx Plus rewards"
      >
        <span class="nugenyx-upcart-benefit__icon">${icons.star}</span>
        <span class="nugenyx-upcart-points">${renderPointsLabel(0)}</span>
      </button>
        <div class="nugenyx-upcart-benefit">
          ${
            labels.benefitImage
              ? `<span class="nugenyx-upcart-benefit__media"><img src="${labels.benefitImage}" alt="Nugenyx travel case with pen presentation box" loading="lazy" width="180" height="135"></span>`
              : `<span class="nugenyx-upcart-benefit__icon">${icons.star}</span>`
          }
          <span class="nugenyx-upcart-benefit__copy">
            <span class="nugenyx-upcart-benefit__title">${labels.benefitTitle}</span>
            <span class="nugenyx-upcart-benefit__text">${labels.benefitText}</span>
          </span>
        </div>
      `;
      modules.appendChild(extras);
    }

    const loyaltyButton = extras.querySelector('.nugenyx-upcart-loyalty');
    if (loyaltyButton && loyaltyButton.dataset.nugenyxRivoBound !== 'true') {
      loyaltyButton.dataset.nugenyxRivoBound = 'true';
      loyaltyButton.addEventListener('click', openRivoWhenReady);
    }
  };

  const updatePoints = (root) => {
    const now = Date.now();
    if (pointsRequest || now - lastPointsRequestAt < 500) return;

    lastPointsRequestAt = now;

    pointsRequest = fetch('/cart.js', { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((cart) => {
        const points = Math.floor((cart.total_price || 0) / 100);
        const pointsElement = root.querySelector('.nugenyx-upcart-points');
        if (pointsElement && (lastPoints !== points || !pointsElement.querySelector('strong'))) {
      pointsElement.innerHTML = renderPointsLabel(points);
          lastPoints = points;
        }

        const subtotalElement = root.querySelector('.nugenyx-upcart-summary__subtotal');
        const shippingElement = root.querySelector('.nugenyx-upcart-summary__shipping-value');
        if (subtotalElement) {
          subtotalElement.textContent = formatMoney(cart.total_price, cart.currency);
        }
        if (shippingElement) {
          shippingElement.textContent =
            (cart.total_price || 0) >= 9900 ? labels.shippingFree : labels.shippingCalculated;
        }
      })
      .catch(() => {})
      .finally(() => {
        pointsRequest = undefined;
      });
  };

  const enhance = (root) => {
    injectStyles(root);

    const heading = root.querySelector('.upcart-internal-header h4');
    if (heading && heading.textContent.trim() !== labels.basket) {
      heading.textContent = labels.basket;
    }

    ensureExtras(root);
    ensureSummary(root);

    const checkout = root.querySelector('.upcart-checkout-button');
    if (checkout && checkout.dataset.nugenyxEnhanced !== 'true') {
      checkout.dataset.nugenyxEnhanced = 'true';
      checkout.innerHTML = `
        <span class="nugenyx-upcart-checkout__icon">${icons.lock}</span>
        <span>${labels.checkout}</span>
      `;
    }

    updatePoints(root);
  };

  const connect = () => {
    const host = document.querySelector('#upCart');
    const root = host?.shadowRoot;
    if (!root) return false;

    enhance(root);

    if (!rootObserver) {
      rootObserver = new MutationObserver(() => {
        window.clearTimeout(updateTimer);
        updateTimer = window.setTimeout(() => enhance(root), 80);
      });
      rootObserver.observe(root, { childList: true, subtree: true });
    }

    return true;
  };

  if (!connect()) {
    const documentObserver = new MutationObserver(() => {
      if (connect()) documentObserver.disconnect();
    });
    documentObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
